import { API_BASE_URL } from "../config";
import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${API_BASE_URL}/api/auth/admin/login`, {
        email,
        password,
      });

      login(res.data.token, res.data.user);
      navigate("/admin");
    } catch (err) {
      if (!err.response) {
        setError("Connecting to backend database server... Please wait a few seconds and try again.");
      } else {
        setError(err.response.data?.message || "Admin login failed. Invalid credentials.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.badge}>ADMIN PORTAL</div>
          <h2 style={styles.title}>Admin Console Login</h2>
          <p style={styles.subtitle}>Platform Management & Risk Monitoring</p>
        </div>

        {error && <div style={styles.errorAlert}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Admin Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@demo.com"
              required
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={styles.input}
            />
          </div>

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "Verifying..." : "Login to Admin Console"}
          </button>
        </form>

        <div style={styles.demoBox}>
          <strong>Default Admin Credentials:</strong>
          <div>Email: <code>admin@demo.com</code> | Password: <code>admin123</code></div>
        </div>

        <div style={styles.footer}>
          <Link to="/login" style={styles.link}>
            ← Return to Client Login
          </Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#1e222d",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  card: {
    width: "100%",
    maxWidth: "420px",
    padding: "36px",
    backgroundColor: "#2a2e39",
    borderRadius: "12px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
    border: "1px solid #363c4e",
    color: "#fff",
  },
  header: {
    textAlign: "center",
    marginBottom: "24px",
  },
  badge: {
    display: "inline-block",
    padding: "4px 10px",
    backgroundColor: "#ef5350",
    color: "#fff",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: "bold",
    letterSpacing: "1px",
    marginBottom: "10px",
  },
  title: {
    margin: 0,
    color: "#fff",
    fontSize: "24px",
    fontWeight: 600,
  },
  subtitle: {
    margin: "6px 0 0",
    color: "#b2b5be",
    fontSize: "14px",
  },
  errorAlert: {
    backgroundColor: "rgba(239, 83, 80, 0.15)",
    color: "#ff8a80",
    padding: "10px 14px",
    borderRadius: "6px",
    fontSize: "14px",
    marginBottom: "16px",
    borderLeft: "4px solid #ef5350",
  },
  formGroup: {
    marginBottom: "18px",
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "13px",
    fontWeight: 500,
    color: "#d1d4dc",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: "6px",
    border: "1px solid #434651",
    backgroundColor: "#1e222d",
    color: "#fff",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#ef5350",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    marginTop: "8px",
  },
  demoBox: {
    marginTop: "20px",
    padding: "10px 12px",
    backgroundColor: "#1e222d",
    borderRadius: "6px",
    fontSize: "12px",
    color: "#b2b5be",
    border: "1px solid #363c4e",
  },
  footer: {
    marginTop: "20px",
    textAlign: "center",
    fontSize: "13px",
  },
  link: {
    color: "#2962ff",
    textDecoration: "none",
    fontWeight: 500,
  },
};

export default AdminLogin;
